<template>
  <div :class="['app-wrapper',leftMenuStatus=='open'?'left-menu-open':'left-menu-close']">
    <span v-hotkey="keymap_adminframe"></span>
    <left-menu/>
    <div class="box-main">
      <div class="box-nav-header">
        <head-navbar/>
      </div>
      <div class="box-main-contain">
        <div class="box-main-contain2 scrollbar1">
        <transition :name="transClass" mode="out-in">
          <keep-alive>
            <router-view :key="routePath"/>
          </keep-alive>
        </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import request1 from '@/common/utils/request';
  import LeftMenu from './admin/LeftMenu';
  import HeadNavbar from './admin/HeadNavbar';

  export default {
    name: 'AdminFrame',
    components: {LeftMenu, HeadNavbar},
    computed: {
      leftMenuStatus() {
        return this.$store.state.leftMenuStatus;
      },
      loginUserInfo() {
        return this.$store.state.loginUserInfo;
      },
      loginTokenInfo(){
        return this.$store.state.tokenInfo;
      },
      routePath() {
        return this.$store.path;
      },
      keymap_adminframe(){
        return{
          'alt+h': this.key_alt_h,
          'alt+j': this.key_alt_j,

        }
      }
    },
    watch: {
      loginUserInfo(newVal, oldVal) {
        if (newVal == null) {
          this._doRouterToLogin();
        }
      },
      $route(newVal,oldVal){
        this.checkPermission();
        this.initPageTitle();
      },


    },

    data() {
      return {
        transClass:'slideRight'
      };
    },
    mounted() {
      if (this.$store.state.loginUserInfo == null) {
        this._doRouterToLogin();
      };

      this.checkPermission();
      this.initPageTitle();
    },
    methods: {
      checkPermission(){
        let userId = this.loginUserInfo.noid;

        let d1 = {user_id:userId};
        let url1 = this.settings.apiBaseUrl + '/daping' ;
        request1.post(url1,d1,{headers:{'Authorization':'Bearer '+this.loginTokenInfo.token} } ).then((d1r)=>{
          if(d1r.code==0){
            let system_manager=false
            if(d1r.data.length>0){
              d1r.data.filter((item, i) => {
                if(item.value==1){
                  system_manager=true
                }
  
              })
            }
            if(!system_manager){
              this.$router.push('/datavisual/index');
            }
            // if(d1r.secret_value.indexOf('system_manager')<0  ){
            //   this.$router.push('/datavisual/index');
            // }

          }
        })

      },
      initPageTitle(){
        let pageTitle = this.settings.appName;

        let rmeta = this.$route.meta;
        if(rmeta!=null && rmeta.pageTitle!=null){
          pageTitle += ' -- ' + rmeta.pageTitle;
        }
        document.title = pageTitle;
      },
      _doRouterToLogin() {
        this.$router.push('/login?redirect=' + this.$route.fullPath);
      },

      key_alt_h(){
        this.$router.push('/admin/index');
      },
      key_alt_j(){
        this.$router.push('/admin/tijian/form');
      },

    }

  };
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/param.scss";

  .app-wrapper{
    position: relative;
    width: 100%;
    height:100%;
    overflow: hidden;

    &.left-menu-close{
      .box-sidebar{
        width:$leftMenuCloseWidth!important;
      }
      .box-main{
        margin-left: $leftMenuCloseWidth;
      }
    }

    .box-main{
      display: flex;
      flex-direction: column;
      position: relative;
      height: 100%;
      margin-left:$leftMenuWidth;
      transition: margin-left $transitionTime;
      -webkit-transition: margin-left $transitionTime;
      background-color: #f4f4f5;
    }

    .box-nav-header{
      flex-grow: 0;
      height: $navbarHeight;
    }
    .box-main-contain{
      flex-grow: 1;
      overflow:hidden;
      .box-main-contain2>>>{
        overflow:auto;
        height: 100%;
        background-color: #f6f6f6;
      }
    }
  }


  .slideRight-enter,.slideRight-leave-to {
    transform: none;
    opacity: 0;
  }
  .slideRight-enter-to,.slideRight-leave{
    opacity: 1;
  }
  .slideRight-enter-active{
    opacity: 1;
  }
   .slideRight-leave-active{
    transition: all .3s ease-out;
    transform: none;
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/AdminFrame.vue